// src/index.js

import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './Store';

import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'react-day-picker/dist/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import "../src/Styles/global.scss";
import "../src/Styles/style.scss";
import "../src/Styles/responsive.scss";
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap-icons/font/bootstrap-icons.css';

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Public mutual-fund factsheet page (/factsheet?mf_id=<id>). Reached only via a fresh
// page load (window.open from fund-detail / Linking.openURL from the mobile app), is
// un-authenticated, and is heavy (@react-pdf/renderer ~1.7MB). Render it as a standalone
// tree — no Redux / OAuth provider / app shell / nav — and lazy-load the bundle so none
// of it ships in the main app chunk.
const Factsheet = lazy(() => import('./Containers/Factsheet/factsheet-document'));
const IS_FACTSHEET_ROUTE = window.location.pathname.replace(/\/+$/, '') === '/factsheet';

// Keep an uncaught error in the (heavy, third-party-laden) factsheet/PDF code from
// blanking the page with no on-screen hint.
class FactsheetBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('Factsheet failed to render:', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'sans-serif', color: '#333' }}>
          <h3 style={{ marginBottom: 8 }}>Couldn't load the factsheet.</h3>
          <p style={{ marginBottom: 12 }}>Please try again later.</p>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, color: '#999' }}>
            {String(this.state.error && (this.state.error.stack || this.state.error.message || this.state.error))}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  IS_FACTSHEET_ROUTE ? (
    <FactsheetBoundary>
      <Suspense fallback={
        <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          Loading…
        </div>
      }>
        <Factsheet />
      </Suspense>
    </FactsheetBoundary>
  ) : (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={clientId}>
        <App />
      </GoogleOAuthProvider>
    </Provider>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
